import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import withWidth, { isWidthDown } from '@material-ui/core/withWidth';
import isEmpty from 'lodash/isEmpty';
import React, { useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { compose } from 'redux';
import ordersFindById from 'State/Store/Orders/Actions/OrdersFindById.action';
import OrderDetails from '../../Components/OrderDetails/OrderDetails.component';
import OrderDetailsHeader from '../../Components/OrderDetailsHeader/OrderDetailsHeader.component';
import Trucks from '../../Components/Trucks/Trucks.component';
import orderItemSelector from '../../State/Store/Orders/Selectors/OrderItem.selector';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import PageTwoColumn from '../Layouts/PageTwoColumn';
import './Order.page.i18n';
import orderPageStyles from './Order.page.styles';
interface Props {
  currentOrder: any;
  orderId: any;
}

interface InjectedProps {
  classes: any;
  width: any;
}

const OrderPageComp = (props: Props & InjectedProps) => {
  const { currentOrder, orderId, classes, width } = props;
  const isSmall = isWidthDown(`sm`, width);
  const [refreshToken, setRefreshToken] = useState(1);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!currentOrder || !currentOrder.summary) {
      getOrder();
    }
  }, []);

  const getOrder = () => {
    const date = orderId.slice(0, orderId.indexOf('-'));
    const orderCode = orderId.slice(orderId.indexOf('-') + 1, orderId.lastIndexOf('-'));
    const orderLine = orderId.slice(orderId.lastIndexOf('-') + 1);
    const requestPayload = {
      date,
      orderCode,
      orderLine,
    };
    dispatch(ordersFindById(requestPayload));
  };

  if (isEmpty(currentOrder)) {
    getOrder();
    return null;
  }

  // We are not using PageTwoColumn here because order details page has the customheader. This can be used later or even switched to two columns template when this is required
  return (
    <PageTwoColumn
      padding="none"
      heading="OrderPage.PageHeading"
      title="OrderPage.PageTitle"
      hideNavbar={isSmall}
      renderExtensions={false}
      rightSidebarClasses={classes.rightSidebar}
      sidebarContentRight={<Trucks orderId={orderId} />}
    >
      <Typography variant="body1" style={{ margin: '16px 0', textAlign: 'center', backgroundColor: '#f1f8e9', padding: '8px 16px', borderRadius: 4 }}>
        <span style={{ color: '#388e3c', fontWeight: 600 }}>
          Important Pricing Update:
        </span>{' '}
        Effective <span style={{ fontWeight: 600 }}>1 June 2026</span>, a Production
        and Transport Surcharge of <span style={{ fontWeight: 600 }}>$8.85 ex GST per m³</span>{' '}
        will apply, due to the recent escalation in global energy and commodity markets which is significantly impacting production and supply chain costs.
      </Typography>
      <Grid classes={{ container: classes.container }} container direction="column" wrap="nowrap">
        <OrderDetailsHeader
          orderId={orderId}
          onRefresh={() => {
            setRefreshToken(refreshToken + 1);
          }}
        />
        <OrderDetails key={refreshToken} orderId={orderId} />
      </Grid>
    </PageTwoColumn>
  );
};

const OrderPage = compose(
  withWidth(),
  withStyles(themeCreateInjectableStyles(orderPageStyles) as any, { withTheme: true }),
  connect(() => (state, ownProps) => {
    const { orderId } = ownProps as any;
    const orderEntitySelector = orderItemSelector(orderId);
    return {
      currentOrder: orderEntitySelector(state),
    };
  }),
)(OrderPageComp);

export default OrderPage;
